import React from "react";
import { TicketErrorHelper } from "../../../Utils/TicketErrorHelper";
import { MenuCardContent, ValidationResult } from "../../../Utils/Interfaces";
import Typography from "@mui/material/Typography";
import TicketValidator, { TICKET_NAVIGATOR } from "../../../Utils/TicketValidator";
import { TicketExtended } from "../../../Utils/TypeExtensions";

export default function TripTicketPdfMenuContent(ticket: TicketExtended, title: string, errors: ValidationResult[]): MenuCardContent {
    let details;

    // TODO need to figure out why we can't rely on the value in context.isReadOnly, we probably have some subtle bugs related to this behaviour
    const isReadonly = TicketValidator.IsReadOnly(ticket);

    if (TicketErrorHelper.hasErrors(errors, TICKET_NAVIGATOR)) {
        details = TicketErrorHelper.getCardErrors(errors, TICKET_NAVIGATOR);
    } else {
        const isStalledSync = TicketValidator.IsStalledSyncStatus(ticket);
        details = (
            <>
                {isStalledSync && (
                    <Typography display={"inline"} textAlign={"center"}>
                        TICKET NOT PROPERLY SYNCED
                    </Typography>
                )}
                {isReadonly && !isStalledSync && (
                    <Typography display={"inline"} textAlign={"center"}>
                        TICKET COMPLETE (READ-ONLY)
                    </Typography>
                )}
                {!isReadonly && TicketErrorHelper.isApprovable(errors) && (
                    <Typography display={"inline"} textAlign={"center"}>
                        SIGNATURE REQUIRED
                    </Typography>
                )}
            </>
        );
    }

    const validationMessages = TicketErrorHelper.getAllErrors(errors);

    return { details: details, validationMessages };
}
